import { FC } from 'react';
import {
  Text,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
  Box,
  VStack,
} from '@chakra-ui/react';
import { NextTierData } from 'app/components/Song/Audio/AudioList/types';

import MainImage from 'resources/images/storage-popup/upgrade-modal-image.png';
import { getStorageFeatures } from 'app/components/Storage/utils';
import { PopupMessageType } from 'app/components/Storage/types';
import { StorageFeatureList } from '../StorageFeatureList';

export interface StorageNotificationDialogProps {
  title: string;
  subtitle: string;
  nextTier: NextTierData;
  isOpen: boolean;
  onClose: (actionable?: boolean) => void;
  disableOverlay?: boolean;
  messageType?: PopupMessageType;
}

export const StorageNotificationDialog: FC<StorageNotificationDialogProps> = ({
  title,
  subtitle,
  nextTier,
  isOpen,
  onClose,
  disableOverlay,
  messageType,
}) => {
  return (
    <Modal size="md" scrollBehavior="inside" isOpen={isOpen} onClose={onClose}>
      {!disableOverlay && <ModalOverlay />}
      <ModalContent data-testid="dialog" maxW={534}>
        <ModalBody position="relative" pt={4} pb={1}>
          <Image src={MainImage} rounded={4} />
          <Box my={4}>
            <Text fontWeight={500} fontSize="lg" mb={0.5}>
              {title}
            </Text>
            <Text>{subtitle}</Text>
          </Box>

          <Text mb={6}>
            <Text as="span" color="B.80">
              {nextTier.tierStorage} of storage
            </Text>{' '}
            from only {nextTier.tierPrice}.
          </Text>
          <StorageFeatureList featureList={getStorageFeatures(messageType)} />
          <VStack mt={4}>
            <Button w="full" onClick={() => onClose(true)}>
              Upgrade now
            </Button>
            <Button w="full" variant="text" onClick={() => onClose()}>
              Maybe later
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
